declare const requestIdleCallback: (callback: () => void) => number;
declare const cancelIdleCallback: (id: number) => void;

export function whenIdle(callback: () => void): () => void {
  if (typeof requestIdleCallback === 'function') {
    const id = requestIdleCallback(callback);
    return () => cancelIdleCallback(id);
  } else {
    const id = requestAnimationFrame(callback);
    return () => cancelAnimationFrame(id);
  }
}
